import { createApp } from 'vue'
import options from './FundraisingHero.options'

const el = '.kb-component--fundraising-hero'

export default function (Store) {
    const DOM = document.querySelectorAll(el)
    if (DOM.length) {
        DOM.forEach((FundraisingHeroDOM) => {
            const template = FundraisingHeroDOM.outerHTML
            options.template = template
            const component = createApp(options).use(Store)
            component.mount(FundraisingHeroDOM)
        })
    }
}
